import React, { useEffect } from "react";
import Typewriter from 'typewriter-effect';
import hop from "../../assets/images/hop.png"
import hero_img from "../../assets/images/hero-img555.png"
import shape1 from "../../assets/images/shape-animation/about-shape-1.png"
import shape2 from "../../assets/images/shape-animation/about-shape-1.png"
import bn from "../../assets/images/bn.jpeg"
import callforlogo from "../../assets/images/callfor-logo.png"
import h2learner1 from "../../assets/images/learner/h2-learner-01.png"
import learner3 from "../../assets/images/learner/h2-learner-02.png"
import learner2 from "../../assets/images/learner/learner-02.png"
import brand4 from "../../assets/images/brand-3.png"
import flash from "../../assets/images/flash.svg"
import { SpiralSpinner, StageSpinner } from "react-spinners-kit";
import { ClipLoader, PropagateLoader, PuffLoader } from "react-spinners";
import withLayout from "../../layouts/withLayout";
import UserHeader from "../../layouts/common/header";


import $ from "jquery"
import UserLayout from "../../layouts/common";
import ScrollAnimation from "react-animate-on-scroll";


const LandingPage = () => {

    useEffect(() => {
        setTimeout(() => {
            $("#preloader").delay(450).fadeOut('slow');
        }, 6300);
    }, [])

    return (
        <div>
            {/* <div>
                <img className="back-image-fade" src={callforlogo} style={{ position: "absolute", bottom: "0em" }} />
            </div> */}
            <div id="preloader">
                <div className="">
                    <img src={callforlogo} style={{ width: "80px" }} className="lloyd-log" />


                </div>
                <div style={{ display: "block" }}>
                    {/* #0573d9 */}
                    <p id="typewriter-text-loader" style={{ fontWeight: '600', color: "#000" }} className="text-left gilroy-800">
                        <Typewriter
                            options={{
                                strings: ["Callforatech.com"],
                                autoStart: true,
                                loop: false,
                                delay: 100,
                                pauseFor: 8000,

                            }}
                        />
                    </p>
                </div>
            </div>

            <div id="page">
                {/* Header Section Start */}
             

                <div className="intro2-section section">
                    <div className="container">
                        <div className="row row-cols-lg-2 row-cols-1 max-mb-n30 mt_2_rem">
                            {/* Intro One Content Start */}
                            <div className="col align-self-center max-mb-30 write_first" data-aos="fade-up">
                                <div className="intro2-content text-center text-md-left">
                                    {/* <h2 className="title text-left gilroy-700"
                                    // style={{ textTransform: "uppercase" }}

                                    >
                                        Be
                                        <span style={{ color: '#2075d6', fontWeight: "700" }}> Smarter by   </span>Getting Advanced Tech.</h2> */}
                                    <h2 className="title text-left gilroy-800 fade-in-text" 
                                    style={{ textTransform: "uppercase" }}
                                    
                                    >
                                          
                                        <span style={{ color: '#2075d6', fontWeight: "800" }}> Certified  </span>Tech Solutions for Every Business.</h2>
                                    <div className="desc">
                                        <p id="typewriter-text" style={{ color: "#000" }} className="text-left gilroy-700">
                                            <Typewriter
                                                options={{
                                                    strings: ["Innovative IT Solutions for Your Business.", "Certified Expertise in Modern Technology."],
                                                    autoStart: true,
                                                    loop: true,
                                                    deleteSpeed:8
                                                }}
                                            />
                                        </p>
                                        <p className="text-left gilroy fade-in-text-sub" style={{ color: '#4F5E64', fontSize: 16 }}>At <span className="gilroy-800" style={{ color: '#000', fontSize: 19 }}>Callforatech,</span> we empower businesses with IT expertise honed over a decade. From web design to data recovery, video surveillance to software development, our certified team delivers transformative solutions tailored to your needs.
                                        </p>
                                    </div>
                                    <div className="row fade-in-text-btn">
                                        <div className="col-5">
                                            <a href="#" className="btn btn-primary btn-hover-secondary flex gilroy-700">Get Started</a>
                                        </div>
                                        <div className="col-4" style={{marginLeft:"-17px"}}>
                                            <a href="#" className="btn btn-outline-primary btn-hover-secondary cml_res gilroy-700 btn-call-width">Learn More &nbsp;<i className="fa fa-arrow-right" /></a>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 mt-5">
                                            <p style={{ fontSize: 16, color: '#66789C' }}>Powered By
                                                <span className="gilroy-700" style={{ color: "#2075d6", fontSize: "23px" }}> Callforatech<span style={{ fontSize: "13px", position: "absolute", top: "6px" }}>&copy;</span></span>
                                                {/* <img src={hop} style={{width: '8rem'}} /> */}
                                            </p>
                                        </div>
                                    </div>
                                    {/* <a href="#" class="btn btn-primary btn-hover-secondary"><i class="far fa-download mr-3"></i> Download free guide</a> */}
                                    {/* <a class="link link-lg" href="course-details-free.html"> Have questions?​ <mark>Get Free Form <i class="far fa-long-arrow-right"></i></mark></a> */}
                                </div>
                            </div>
                            {/* Intro One Content End */}
                            {/* Intro One Course Start */}
                            <div className="col " data-aos="fade-up">
                                <div className="contact-image intro2-image">
                                    <img style={{width:"500px"}} src={hero_img} className="banner_anim" alt />
                                    {/* Animation Shape Start */}
                                    <div className="shape shape-1 scene">
                                        <span data-depth={3}>
                                            <img src={shape1} alt />
                                        </span>
                                    </div>
                                    <div className="shape shape-2 scene">
                                        <span data-depth={-3}><img src={shape1} alt /></span>
                                    </div>
                                    {/* <div class="shape shape-3 scene">
                                      <span data-depth="4">shape 3</span>
                                  </div> */}
                                    <div className="shape shape-4 scene">
                                        {/* <span data-depth={4}><img src={subshape} alt /></span> */}
                                    </div>
                                    {/* <div class="shape shape-5 scene">
                                      <span data-depth="4"><img src="assets/images/shape-animation/nwesletter-shape-2.png" alt=""></span>
                                  </div> */}
                                    {/* Animation Shape End */}
                                </div>
                            </div>
                            {/* Intro One Course End */}
                        </div>
                    </div>
                </div>

                <div className="section section-padding">
                    <div className="container">

                        <div className="learners-section section section-padding" style={{ marginTop: "-2em" }}>
                            <div className="container">
                                {/* Section Title Start */}
                                <div className="section-title text-center" data-aos="fade-up">
                                    <span className="sub-title">Explore Our Tech Services Portfolio</span>
                                    <h2 className="title gilroy-700">Discover   <span className="gilroy-700">Customized</span> Tech Solutions for Growth.</h2>
                                </div>
                                {/* Section Title End */}
                                {/* Feature Wrapper Start */}
                                <ScrollAnimation animateIn='fadeInUp'
                                    animateOut='fadeOut'>
                                <div className="row row-30 row-cols-xl-3 row-cols-sm-2 row-cols-1 max-mb-n30">
                                    {/* Feature Start (Icon Box) */}
                                    <div className="col max-mb-30" data-aos="fade-up">
                                        <a className="icon-box icon-box-left text-left">
                                            <div className="icon">
                                                <img src={h2learner1} alt />
                                            </div>
                                            <div className="content">
                                                <h3 className="title raleway-700">Tailored IT Solutions</h3>
                                                <div className="desc">
                                                    <p>We deliver customized software and hardware services designed to meet your unique business needs and drive success.</p>
                                                </div>
                                                <span className="link">Start here <i className="fa fa-long-arrow-right" /></span>
                                            </div>
                                        </a>
                                    </div>
                                    {/* Feature Start (Icon Box) */}
                                    {/* Feature Start (Icon Box) */}
                                    <div className="col max-mb-30" data-aos="fade-up">
                                        <a className="icon-box icon-box-left text-left">
                                            <div className="icon">
                                                <img src={learner2} alt />
                                            </div>
                                            <div className="content">
                                                <h3 className="title raleway-700">Seamless Technology Integration</h3>
                                                <div className="desc">
                                                    <p>Our team ensures smooth implementation of cutting-edge systems, making your operations efficient and future-ready.</p>
                                                </div>
                                                <span className="link">Get Free Quote <i className="fa fa-long-arrow-right" /></span>
                                            </div>
                                        </a>
                                    </div>
                                    {/* Feature Start (Icon Box) */}
                                    {/* Feature Start (Icon Box) */}
                                    <div className="col max-mb-30" data-aos="fade-up">
                                        <a className="icon-box icon-box-left text-left">
                                            <div className="icon">
                                                <img src={learner3} alt />
                                            </div>
                                            <div className="content">
                                                <h3 className="title raleway-700">Reliable Tech Support</h3>
                                                <div className="desc">
                                                    <p>Experience responsive and dependable support, addressing all your IT challenges with precision and expertise.</p>
                                                </div>
                                                <span className="link">Start here <i className="fa fa-long-arrow-right" /></span>
                                            </div>
                                        </a>
                                    </div>
                                    {/* Feature Start (Icon Box) */}
                                </div>
                                    </ScrollAnimation>
                                {/* Feature Wrapper End */}
                            </div>
                        </div>
                        {/* 
        <div className="row row-cols-lg-2 row-cols-sm-1 max-mb-n30 mt-5">
          <div className="col max-mb-30" data-aos="fade-up">
            <div className="course-3 shadow-sm" style={{backgroundColor: '#FFF6F1', border: '1px solid #E0E6F7'}}>
              <div className>
                <a href="#" className="image"><img className="cus_crd_img" src="assets/images/job-tools.png" alt="Course Image" /></a>
              </div>
              <div className="info">
                <h3 className="title" style={{fontSize: 28, color: '#05264E'}}>Did you know?</h3>
                <p style={{color: '#66789C', fontWeight: 500}}>
                  ICDL is mapped to the DigComp framework (European Union), the National Register of Professional Qualification (France),
                  the National Qualifications Framework (England), and the Workforce Skills Qualification Framework (Singapore).
                </p>
                <a className="link" style={{marginTop: 10, color: '#2075d6', fontWeight: 'bold'}} href="#">Find out more <i className="far fa-long-arrow-right" /></a>
              </div>
            </div>
          </div>
          <div className="col max-mb-30" data-aos="fade-up">
            <div className="course-3 shadow-sm" style={{backgroundColor: '#EFF7FF', border: '1px solid #E0E6F7'}}>
              <div className>
                <a href="course-details-standard-sidebar.html" className="image"><img className="cus_crd_img" src="assets/images/planning-job.png" alt="Course Image" /></a>
              </div>
              <div className="info">
                <h3 className="title" style={{fontSize: 28, color: '#05264E'}}>CDL Certification</h3>
                <p style={{color: '#66789C', fontWeight: 500}}>Does certification matter? There are lots of ways to learn how to use a computer, but research done by partners of ICDL
                  Foundation shows that proving acquired skills with certification is key to truly equipping people with useful
                  competences.</p>
                <a className="link" style={{marginTop: 10, color: '#2075d6', fontWeight: 'bold'}} href="#">Find out more <i className="far fa-long-arrow-right" /></a>
              </div>
            </div>
          </div>
        </div> */}
                        {/* <div class="row max-mt-50">
                      <div class="col text-center">
                          <a href="courses-grid-3.html" class="btn btn-primary btn-hover-secondary"> View all courses <i class="far fa-long-arrow-right ml-3"></i></a>
                      </div>
                  </div> */}
                    </div>
                </div>
                
                <div className="about-video-section section position-relative section-padding-bottom-160">
                    <ScrollAnimation animateIn='fadeInUp'
                    animateOut='fadeOut'>
                    <div className="container_cust_alt">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                {/* About Me Video Wrapper Start */}
                                    <img src={bn} className style={{ width: '100%', width: "80%", borderRadius: "10%", border:"17px solid #a6d5ffc9" }} alt />
                                {/* About Me Video Wrapper End */}
                            </div>
                            <div className="col-lg-5">
                                <div className=" max-width-100 pl-60 pl-md-20 pl-sm-0 pl-xs-0 mt-sm-50 mt-xs-50">
                                    <span className=" jakarta" style={{ color: '#A0ABB8', fontSize: 32, fontWeight: 800 }}>Callforatech</span>
                                    <h2 className style={{ color: '#05264E', fontSize: 52, fontWeight: 800 }}>Cutting Edge <span style={{ color: '#2075d6' }}>Solution</span> for Businesses</h2>
                                    <p className="jakarta mt-4" style={{ color: '#05264E' }}>
                                        We have been serving the IT needs of small businesses, govt. contractors and large corporations throughout the country for over 5 years. Our trained and certified staff have over 10 years field experience with backgrounds in both the Govt. and Corporate IT Sector. We are here for your Business Solutions we offer Web-Design, Programming, Video Surviellance, Software Development, Data Networking, Remote Access, Data Recovery, Computer Repair, POS Systems, Installations/Upgrades, Terminals/AP, Towers, Servers and more.
                                    </p>
                                    {/* <div className="d-flex" style={{ gap: 30 }}>
                                        <a href="page-register.html" className="btn btn-primary">Enrol</a>
                                        <a className="link" style={{ marginTop: 10, color: '#4d4c55' }} href="#">Learn more <i className="far fa-long-arrow-right" /></a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    </ScrollAnimation>
                    {/* Section Bottom Shape Start */}
                    <div className="section-bottom-shape-two">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none" height={315}>
                            <path className="elementor-shape-fill" d="M 50 0 S75 0 100 100 L100 0" />
                        </svg>
                    </div>
                    {/* Section Bottom Shape End */}
                </div>
                

                {/* Course Section End */}
                {/* Blog Section Start */}
                {/* Blog Section End */}
                {/* Learners Section Start */}
                <div className="learners-section section section-padding">
                    <div className="container_cust_alt">
                        {/* Section Title Start */}
                        <div className="section-title text-center" data-aos="fade-up">
                            <h2 className="raleway-700" style={{ color: '#05264E' }}><span style={{ color: "#2075d6" }}>Callforatech</span> Services &amp; Solutions</h2>
                            <p className="jakarta" style={{ color: '#66789C', fontSize: 18 }}>In Partnership with Experts, We Deliver These Services</p>
                        </div>

                        <div className="row  row-cols-lg-4 row-cols-md-2 row-cols-1">
                            <ScrollAnimation animateIn='fadeInUp'
                                animateOut='fadeOut'>
                            <div className="col max-mb-30" data-aos="fade-up">
                                <div className="blog-2 p-4" style={{ backgroundColor: '#F8FAFF', border: '1px solid #E0E6F7', height: 'auto!important' }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={brand4} />
                                        </div>
                                        <div className="col-7">
                                            <p className="jakarta raleway-700" style={{ fontWeight: 'bold', color: '#05264E', fontSize: 18 }}>For Businesses</p>
                                            {/* <p style={{ color: '#A0ABB8', fontSize: 12, marginTop: '-15px' }}><i className="fa fa-map-marker" />Abia Poly, NG.</p> */}
                                        </div>
                                        <div className="col-2">
                                            <img src={flash} />
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <p className="jakarta" style={{ color: '#4F5E64', fontWeight: 500, fontSize: 14 }}>
                                                Web-Design, Programming, Video Surviellance, Software Development, DataNetworking, Data Recovery,
                                                Repairs, POS Systems, Installations,
                                                Upgrades, Terminals/AP, Servers.
                                                Contact Us for needs.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <a href="page-register.html" className="btn btn-primary" style={{ backgroundColor: '#E0E6F7', color: '#2075d6', border: 'none', fontWeight: 500, width: '7rem', height: '2.7rem' }}>see more</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn='fadeInUp'
                                animateOut='fadeOut'>
                            <div className="col max-mb-30" data-aos="fade-up">
                                <div className="blog-2 p-4" style={{ backgroundColor: '#F8FAFF', border: '1px solid #E0E6F7', height: 'auto!important' }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={brand4} />
                                        </div>
                                        <div className="col-7">
                                            <p className="jakarta raleway-700" style={{ fontWeight: 'bold', color: '#05264E', fontSize: 18 }}>Computer Networking</p>
                                            {/* <p style={{ color: '#A0ABB8', fontSize: 12, marginTop: '-15px' }}><i className="fa fa-map-marker" />Abia Poly, NG.</p> */}
                                        </div>
                                        <div className="col-2">
                                            <img src={flash} />
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <p className="jakarta" style={{ color: '#4F5E64', fontWeight: 500, fontSize: 14 }}>
                                                Need to communicate between computers in your Home or Office? Want to remote access your computers from anywhere. We have the Networking Solutions you need. Starting at just $75
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <a href="page-register.html" className="btn btn-primary" style={{ backgroundColor: '#E0E6F7', color: '#2075d6', border: 'none', fontWeight: 500, width: '7rem', height: '2.7rem' }}>see more</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn='fadeInUp'
                                animateOut='fadeOut'>
                            <div className="col max-mb-30" data-aos="fade-up">
                                <div className="blog-2 p-4" style={{ backgroundColor: '#F8FAFF', border: '1px solid #E0E6F7', height: 'auto!important' }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={brand4} />
                                        </div>
                                        <div className="col-7">
                                            <p className="jakarta raleway-700" style={{ fontWeight: 'bold', color: '#05264E', fontSize: 18 }}>Software Upgrades</p>
                                            {/* <p style={{ color: '#A0ABB8', fontSize: 12, marginTop: '-15px' }}><i className="fa fa-map-marker" />Abia Poly, NG.</p> */}
                                        </div>
                                        <div className="col-2">
                                            <img src={flash} />
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <p className="jakarta" style={{ color: '#4F5E64', fontWeight: 500, fontSize: 14 }}>
                                                Need to Upgrade your unit to the latest Operating System or need New Software installed? Upgrades start at just $75
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <a href="page-register.html" className="btn btn-primary" style={{ backgroundColor: '#E0E6F7', color: '#2075d6', border: 'none', fontWeight: 500, width: '7rem', height: '2.7rem' }}>see more</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn='fadeInUp'
                                animateOut='fadeOut'>
                            <div className="col max-mb-30" data-aos="fade-up">
                                <div className="blog-2 p-4" style={{ backgroundColor: '#F8FAFF', border: '1px solid #E0E6F7', height: 'auto!important' }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={brand4} />
                                        </div>
                                        <div className="col-7">
                                            <p className="jakarta raleway-600" style={{ fontWeight: 'bold', color: '#05264E', fontSize: 18 }}>Mobile Devices</p>
                                            {/* <p style={{ color: '#A0ABB8', fontSize: 12, marginTop: '-15px' }}><i className="fa fa-map-marker" />Abia Poly, NG.</p> */}
                                        </div>
                                        <div className="col-2">
                                            <img src={flash} />
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <p className="jakarta" style={{ color: '#4F5E64', fontWeight: 500, fontSize: 14 }}>
                                                Upgrades, Downloads, Data Recovery, Data Transfer, Password Unlock and more.
                                                Starting at just $50
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row mt-5">
                                        <div className="col-12">
                                            <a href="page-register.html" className="btn btn-primary" style={{ backgroundColor: '#E0E6F7', color: '#2075d6', border: 'none', fontWeight: 500, width: '7rem', height: '2.7rem' }}>see more</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </ScrollAnimation>

                        </div>
                    </div>
                </div>
                {/* Funfact Section Start */}
                {/* <div className="funfact-section section" style={{ marginTop: '-6rem' }}>
                    <div className="container funfact-border bg-pattern">
                        <div className="row">
                            <div className="col-lg-12 mx-auto">
                                <div className="row row-cols-lg-4 row-cols-md-2 row-cols-1">
                                    <div className="col" data-aos="fade-up">
                                        <div className="funfact funfact-style-two max-mb-50">
                                            <div className="number"><span className="counter">25</span><span> K+</span></div>
                                            <h2 className style={{ color: '#05264E', fontSize: 20, fontWeight: 700 }}>Completed Cases </h2>
                                            <p className="jakarta" style={{ fontSize: 14, color: '#4F5E64', fontWeight: 500 }}>We always provide people a
                                                complete solution upon focused of
                                                any businesss</p>
                                        </div>
                                    </div>
                                    <div className="col" data-aos="fade-up">
                                        <div className="funfact funfact-style-two max-mb-50">
                                            <div className="number"><span className="counter">17</span><span> +</span></div>
                                            <h2 className style={{ color: '#05264E', fontSize: 20, fontWeight: 700 }}>Our Office </h2>
                                            <p className="jakarta" style={{ fontSize: 14, color: '#4F5E64', fontWeight: 500 }}>
                                                We always provide people a
                                                complete solution upon focused of
                                                any business
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col" data-aos="fade-up">
                                        <div className="funfact funfact-style-two max-mb-50">
                                            <div className="number"><span className="counter">86</span><span> +</span></div>
                                            <h2 className style={{ color: '#05264E', fontSize: 20, fontWeight: 700 }}>Skilled People</h2>
                                            <p className="jakarta" style={{ fontSize: 14, color: '#4F5E64', fontWeight: 500 }}>
                                                We always provide people a
                                                complete solution upon focused of
                                                any business
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col" data-aos="fade-up">
                                        <div className="funfact funfact-style-two max-mb-50">
                                            <div className="number"><span className="counter">28</span><span> +</span></div>
                                            <h2 className style={{ color: '#05264E', fontSize: 20, fontWeight: 700 }}>CHappy Clients </h2>
                                            <p className="jakarta" style={{ fontSize: 14, color: '#4F5E64', fontWeight: 500 }}>
                                                We always provide people a
                                                complete solution upon focused of
                                                any business
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
              
           
                {/* Newsletter Section Start */}
                <div className="newsletter-section section section-padding position-relative">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="newsletter-content nl_bg" style={{ backgroundImage: 'url(assets/images/bg-newsletter.svg)', backgroundRepeat: 'no-repeat' }}>
                                    <div style={{ position: 'absolute', width: '100%' }} className="nl_tp">
                                        <h2 className="title text-white">Subscribe to our newsletter</h2>
                                        <p className="jakarta text-white" style={{ fontWeight: 500, fontSize: 18, marginTop: 0 }}>Stay updated about News and Events </p>
                                        <div className="newsletter-form">
                                            <center>
                                                <div className="row pg_gy" style={{ backgroundColor: '#fff', borderRadius: 13, width: '88%' }}>
                                                    <div className="col-1 res_show">
                                                        <i className="fa fa-envelope" style={{ fontSize: 21, marginTop: 14 }} />
                                                    </div>
                                                    <div className="col-lg-11 col-12 ">
                                                        <form action="#" className="mt_inp">
                                                            <input className="jakarta in_w" type="email" placeholder="Enter your email here" style={{ backgroundColor: '#fff', border: 'none!important' }} />
                                                            <button className="btn btn-primary btn-hover-secondary bt_nl_w">Subscribe</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </center>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Newsletter Section End */}
              
              
                <a href="#" className="scroll-top" id="scroll-top">
                    <i className="arrow-top fal fa-long-arrow-up" />
                    <i className="arrow-bottom fal fa-long-arrow-up" />
                </a>
                {/* Scroll Top End */}
            </div>
            <div id="site-main-mobile-menu" className="site-main-mobile-menu">
                <div className="site-main-mobile-menu-inner">
                    <div className="mobile-menu-header">
                        <div className="mobile-menu-logo">
                            <a href="index.html"><img style={{ width: '4rem' }} src="assets/images/logo.png" alt /></a>
                        </div>
                        <div className="mobile-menu-close">
                            <button className="toggle">
                                <i className="icon-top" />
                                <i className="icon-bottom" />
                            </button>
                        </div>
                    </div>
                    <div className="mobile-menu-content">
                        <nav className="site-mobile-menu">
                            <ul>
                                <li className="has-children position-static">
                                    <a href="index.html"><span className="menu-text jakarta">Home</span></a>
                                    {/* <span class="menu-toggle"><i class="far fa-angle-down"></i></span> */}
                                </li>
                                <li className="has-children">
                                    <a href="#"><span className="menu-text jakarta">Certification</span></a>
                                    {/* <span class="menu-toggle"><i class="far fa-angle-down"></i></span> */}
                                </li>
                                <li className="has-children">
                                    <a href="#"><span className="menu-text jakarta">ICDL Modules</span></a>
                                    {/* <span class="menu-toggle"><i class="far fa-angle-down"></i></span> */}
                                </li>
                                <li className="has-children">
                                    <a href="about-us-1.html"><span className="menu-text jakarta">About us</span></a>
                                    {/* <span class="menu-toggle"><i class="far fa-angle-down"></i></span> */}
                                </li>
                                <li className="has-children">
                                    <a href="page-contact.html"><span className="menu-text jakarta">Contact us</span></a>
                                    {/* <span class="menu-toggle"><i class="far fa-angle-down"></i></span> */}
                                </li>
                                <li className="has-children">
                                    <a href="page-register.html"><span className="menu-text jakarta">Get Certitified</span></a>
                                    {/* <span class="menu-toggle"><i class="far fa-angle-down"></i></span> */}
                                </li>
                            </ul>
                        </nav>
                        <div className="mt-5">
                            <p className="text-left">Copyright 2024 ©</p>
                            <p className="text-left" style={{ marginTop: '-18px' }}>Powered by Hopewell Solution Services.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default withLayout(UserLayout)(LandingPage);